import { UsersTable } from '@app/shared/tables/users-table/UsersTable';
import { ERole } from '@app/swagger-types';
import { useMatchActiveRoute } from '@app/router';
import { Routes } from '@app/constants/routes';

export const AdminsPage = () => {
  const isActive = useMatchActiveRoute([Routes.admin.user_management.admins]);

  return (
    <div className={isActive ? 'block' : 'hidden'}>
      <UsersTable role={ERole.ROLE_ADMIN} />
    </div>
  );
};
